import usEnglist from './en-US';

export default {
  'en-US': usEnglist
};
